import { MobiDocument } from './MobiDocument';

export class AutorisationEtablissement extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private autorisation_id: number;
    private etablissementautorise_id: number;

    public constructor(autorisationEtablissement: any) {
        super();
        this._id = autorisationEtablissement._id;
        this._rev = autorisationEtablissement._rev;
        this.id = autorisationEtablissement.id;
        this.autorisation_id = autorisationEtablissement.autorisation_id;
        this.etablissementautorise_id = autorisationEtablissement.etablissementautorise_id;
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getAutorisation_id(): number {
        return this.autorisation_id;
    }

    public setAutorisation_id(autorisation_id: number): void {
        this.autorisation_id = autorisation_id;
    }

    public getEtablissementautorise_id(): number {
        return this.etablissementautorise_id;
    }

    public setEtablissementautorise_id(etablissementautorise_id: number): void {
        this.etablissementautorise_id = etablissementautorise_id;
    }

}